<template>
  <span class="plm">
    <span class="plm-badge plm-cycle">{{ cycleLabel }}</span>
    <span class="plm-badge" :class="timingClass">{{ timingLabel }}</span>
  </span>
</template>

<script>
/**
 * Compact read-only badges for a subscription payment line's billing cycle + payment
 * timing (prepaid/postpaid). Drop it next to any line display so the cadence is visible
 * everywhere lines appear (renew, details, lists). Globally registered in main.js.
 *
 *   <PaymentLineMeta :line="payment" />
 */
export default {
  name: "PaymentLineMeta",
  props: {
    line: { type: Object, default: () => ({}) },
  },
  computed: {
    cycleLabel() {
      return this.line?.billing_cycle || "—";
    },
    isPostpaid() {
      return String(this.line?.payment_timing || "").toLowerCase() === "postpaid";
    },
    timingLabel() {
      return this.isPostpaid ? "Postpaid" : "Prepaid";
    },
    timingClass() {
      return this.isPostpaid ? "plm-postpaid" : "plm-prepaid";
    },
  },
};
</script>

<style scoped>
.plm {
  display: inline-flex;
  gap: 4px;
  vertical-align: middle;
}
.plm-badge {
  font-size: 0.68rem;
  font-weight: 600;
  padding: 1px 7px;
  border-radius: 999px;
  white-space: nowrap;
}
.plm-cycle {
  background: #eef2ff;
  color: #1d2088;
}
.plm-prepaid {
  background: #ecfdf5;
  color: #047857;
}
.plm-postpaid {
  background: #fef3c7;
  color: #92400e;
}
</style>
